import * as React from "react";
import { IInputFieldProps, ObjectFieldSchema } from "@generation/core";
//eslint-disable-next-line import/no-cycle
import { RenderFields } from "../Form/RenderFields";
import { useFieldRenderContext } from "../Context/FieldRenderContextProvider";
import { renderAddedSchemaFields } from "../Interfaces/renderAddedSchemaFields";
import { withFormFieldHoc } from "./hoc/withFormFieldHoc";

export const ObjectField = (renderAddedSchemaFields?: renderAddedSchemaFields) =>
  React.memo(
    withFormFieldHoc((props: IInputFieldProps<ObjectFieldSchema>) => {
      const renderContext = useFieldRenderContext();

      if (!renderContext) {
        return <></>;
      }

      return (
        <>
          <renderContext.object field={props.field}>
            {Object.entries(props.field.properties).map(([fieldName, objectField]) => (
              <React.Fragment key={`${props.name}.${fieldName}`}>
                <RenderFields
                  field={objectField}
                  name={`${props.name}.${fieldName}`}
                  renderAddedSchemaFields={renderAddedSchemaFields}
                />
              </React.Fragment>
            ))}
          </renderContext.object>
        </>
      );
    })
  );
